import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

const LineChart = () => {
    const [state] = useState({
        series: [{
            name: "Status Messages",
            data: [80, 30, 45, 60, 60, 100, 100, 90, 85, 70, 65, 63, 62, 60, 70, 62, 35, 62, 70, 75, 80]
        }],
        options: {
            chart: {
                height: 300, 
                type: 'line',
                zoom: { enabled: false },
                toolbar: { show: false }
            },
            dataLabels: { enabled: false },
            stroke: {
                curve: 'straight',
                width: 2
            },
            markers: {
                size: 4,
                colors: ['#007bff'],
                strokeWidth: 2,
            },
            xaxis: {
                categories: ['10/16', '', '', '', '10/20', '', '', '', '10/24', '', '', '10/28', '', '', '11/01', '', '', '11/05', '', '', '11/09'],
                labels: { rotate: -45, style: { fontSize: '12px' } }
            },
            yaxis: {
                labels: { formatter: (value) => `${value}%` }
            },
            legend: { show: true, position: 'bottom' }
        },
    });

    return (
        <div className="p-3 border rounded bg-white" style={{ height: '90%', width: '100%' }}>
            <ReactApexChart options={state.options} series={state.series} type="line" height={250} />
        </div>
    );
};

const PieChart = () => {
    const [state] = useState({
        series: [45, 55, 40],
        options: {
            chart: {
                type: 'pie',
            },
            labels: ['Critical Error', 'Stable Device', 'Warnings'],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        },
    });

    return (
        <div className="p-3 border rounded bg-white" style={{ height: '90%' }}>
            <ReactApexChart options={state.options} series={state.series} type="pie" height={250} />
        </div>
    );
};

const Health = () => {
    const [selected, setSelected] = useState("ALPR");
    const buttons = ["ALPR", "RFID", "Display Boards", "Boom Barriers", "USS", "Gateway"];

    return (
        <div className="m-4">
            <div className="row mb-3 ms-2 me-2 text-center">
                {buttons.map((btn, index) => (
                    <div className="col-md-2 d-flex justify-content-center" key={btn}>
                        <button
                            className={`btn rounded-0 w-100 ${selected === btn ? 'btn-dark' : 'btn-secondary'}`}
                            onClick={() => setSelected(btn)}
                        >
                            {btn}
                        </button>
                    </div>
                ))}
            </div>
            <div className="row mt-4 ms-2 me-2" >
                <div className="col-md-4">
                    <PieChart />
                </div>
                <div className="col-md-8">
                    <LineChart />
                </div>
            </div>
            <div className="row ms-2 me-2">
                <div className="col-md-4 bg-white me-3 border rounded shadow-sm p-3" style={{ width: "410px" }}>
                    <div className="border-bottom pb-2">
                        <h6 className="mb-3 fw-bold text-danger">🔴 Recent Errors</h6>
                    </div>
                    <div className="table-responsive">
                        <table className="table text-center table-sm">
                            <thead className="table-danger">
                                <tr>
                                    <th>Time</th>
                                    <th>Error Type</th>
                                    <th>Action Taken</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>10:30 AM</td>
                                    <td>Camera Not Responding</td>
                                    <td><span className="badge bg-warning">Restarted</span></td>
                                </tr>
                                <tr>
                                    <td>09:45 AM</td>
                                    <td>Slow Processing</td>
                                    <td><span className="badge bg-info">Investigating</span></td>
                                </tr>
                                <tr>
                                    <td>08:20 AM</td>
                                    <td>Network Failure</td>
                                    <td><span className="badge bg-success">Reconnected</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="col-md-4 bg-white me-3 border rounded shadow-sm p-3" style={{ width: "450px" }}>
                    <div className="border-bottom pb-2">
                        <h6 className="mb-3 fw-bold text-primary">🛠 Maintenance Status</h6>
                    </div>
                    <div className="table-responsive">
                        <table className="table text-center table-sm">
                            <thead className="table-primary">
                                <tr>
                                    <th>Date</th>
                                    <th>Issue Fixed</th>
                                    <th>Fixed By</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>March 28</td>
                                    <td>Camera Failure</td>
                                    <td>Technician A</td>
                                    <td><span className="badge bg-success">Resolved</span></td>
                                </tr>
                                <tr>
                                    <td>March 24</td>
                                    <td>Network Issue</td>
                                    <td>IT Team</td>
                                    <td><span className="badge bg-warning">In Progress</span></td>
                                </tr>
                                <tr>
                                    <td>March 15</td>
                                    <td>Software Update</td>
                                    <td>Automated</td>
                                    <td><span className="badge bg-success">Completed</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="col-md-3 bg-white border rounded shadow-sm p-2">
                    <div className="border-bottom pb-2 mt-2">
                        <h6 className="mb-3 fw-bold text-warning fs-6">🔔 Alerts & Notifications</h6>
                    </div>
                    <div className="p-1">
                        <ul className="list-unstyled">
                            <li className="alert alert-danger p-1 m-1 text-truncate">
                                <strong>⚠️ Critical Alert:</strong> ALPR error rate exceeded 15%!
                            </li>
                            <li className="alert alert-warning p-1 m-1 text-truncate">
                                <strong>⚠️ Warning:</strong> Slow processing on ALPR-202.
                            </li>
                            <li className="alert alert-success p-1 m-1 text-truncate">
                                <strong>✅ Stable:</strong> ALPR-101 running smoothly.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Health;